export const ao3Assets = {
  logo: "/images/logo.png",
  mascotReading: "/images/mascot-reading.png",
  mascotWalking: "/images/mascot-walking.png",
  heroBackground: "/images/hero-bg.jpg",
  ctaBackground: "/images/cta-bg.jpg",
};

export const ao3ScreenshotImages = [
  {
    id: "loading",
    image: "/images/screenshot-loading.png",
  },
  {
    id: "home",
    image: "/images/screenshot-home.png",
  },
  {
    id: "search",
    image: "/images/screenshot-search.png",
  },
  {
    id: "translate",
    image: "/images/screenshot-translate.png",
  },
  {
    id: "navigation",
    image: "/images/screenshot-navigation.png",
  },
];

export const ao3Features = [
  { id: "reader", icon: "ri-book-open-line" },
  { id: "offline", icon: "ri-download-cloud-line" },
  { id: "sync", icon: "ri-refresh-line" },
  { id: "tags", icon: "ri-price-tag-3-line" },
  { id: "night", icon: "ri-moon-clear-line" },
  { id: "platforms", icon: "ri-device-line" },
];

export const ao3Platforms = [
  { id: "android", key: "android", icon: "ri-android-line" },
  { id: "ios", key: "ios", icon: "ri-apple-line" },
  { id: "harmonyos", key: "harmonyos", icon: "ri-smartphone-line" },
  { id: "windows", key: "windows", icon: "ri-windows-line" },
];

export const ao3Stats = [
  { id: "works", value: "12M+", icon: "ri-book-2-line" },
  { id: "readers", value: "500K+", icon: "ri-user-heart-line" },
  { id: "rating", value: "4.9", icon: "ri-star-smile-line" },
  { id: "languages", value: "60+", icon: "ri-translate-2" },
];

export const ao3Faqs = ["what", "free", "hostError", "platforms", "entry"];

export const ao3NavItems = [
  { id: "home", target: "ao3-top" },
  { id: "features", target: "ao3-features" },
  { id: "screenshots", target: "ao3-screenshots" },
  { id: "platforms", target: "ao3-platforms" },
  { id: "faq", target: "ao3-faq" },
];

export const ao3Keywords = [
  "AO3阅读器",
  "AO3.CUBEART.CLUB HOST ERROR",
  "HOME | ARCHIVE OF OUR OWN",
  "AO3链接入口",
];